/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Arbeitgebermitadresse2Inputs */



/**

* @param {_Field_Arbeitgebermitadresse2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_arbeitgebermitadresse2 = /** @type {((inputs?: _Field_Arbeitgebermitadresse2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Arbeitgebermitadresse2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Arbeitgeber mit Adresse")
});
export { _field_arbeitgebermitadresse2 as "_field_arbeitgeberMitAdresse" }